import { clearSessionCache } from "@/src/services/blocks/session";
import { ssoLogout } from "@/src/services/blocks/sso";
import { authEvents } from "./auth-events";

/**
 * Session-failure handling for the v4 hosted-SSO model.
 *
 * There is no client-side token rotation here any more. Renewal is
 * `refreshSession()` in `src/services/blocks/sso.ts` — Blocks rotates the
 * HttpOnly cookies server-side, so nothing is returned to hold. `axios.ts` and
 * `graphql.client.ts` call it directly on a 401 and retry once.
 *
 * The v1 `coordinatedRefresh`/`doRefresh` pair that lived here is gone: it
 * de-duplicated concurrent refreshes of a JS-held token pair and wrote them back
 * into `accountStore`. Neither applies to a cookie session, and it had no callers.
 */

export const MAX_REFRESH_ATTEMPTS = 2;

/**
 * Terminal auth failure — refresh could not recover the session. Revoke it
 * server-side, drop the cached identity/org, and let the app react.
 *
 * `ssoLogout` is best-effort: if the session is already dead the revoke call may
 * fail, and that must not stop us clearing local state and signalling logout.
 */
export const handleAuthFailure = async (): Promise<void> => {
  try {
    await ssoLogout();
  } catch {
    // already invalid server-side — nothing to revoke
  }
  clearSessionCache();
  authEvents.triggerLogout();
};
